import { render, staticRenderFns } from "./FilterIndividuals.vue?vue&type=template&id=2b739e76&"
import script from "./FilterIndividuals.vue?vue&type=script&lang=js&"
export * from "./FilterIndividuals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports